import { FormControl, FormLabel } from "@mui/material";
import { Form } from "react-bootstrap";
import styled from "styled-components";

const StyledForm = styled(Form)`
  & .FormGroup {
    padding-left: 40px;
    padding-right: 40px;
  }
`;

const MUIDeviceFormControl = styled(FormControl)`
  font-size: 0.8rem !important;
`;

const MUIDeviceFormLabel = styled(FormLabel)`
  font-size: 0.8rem !important;
  color: inherit !important;
  margin-bottom: 0.5rem;
`;

const paddingStyle = { paddingLeft: "40px", paddingRight: "40px" };

export { StyledForm, MUIDeviceFormControl, MUIDeviceFormLabel, paddingStyle };
